import { navigate } from 'gatsby'
import React, { Component } from 'react'

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class EventForm extends Component {
  state = {
    pathname: '',
    form: {},
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
  }

  componentDidMount() {
    this.setState({ pathname: window.location.pathname })
  }

  handleChange = e => {
    let { form } = this.state
    if (e.target.name === 'type') {
      let current = form[e.target.name] || ''
      if (current.indexOf(e.target.value) === -1) {
        // add
        form[e.target.name] = current + ' ' + e.target.value
      } else {
        // remove
        form[e.target.name] = current.replace(' ' + e.target.value, '')
      }
    } else {
      form[e.target.name] = e.target.value
    }
    form['page'] = this.state.pathname
    this.setState({ form })
  }

  handleSubmit = async (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    const formData = new FormData(this.form.current)
    formData.append('form-name', this.form.current.getAttribute("name"))
    const queryString = new URLSearchParams(formData).toString()

    this.setState({result: 'success'})

    // https://zapier.com/editor/204112019/published/204112020/sample
    await fetch("https://hooks.zapier.com/hooks/catch/2181815/39z0xmx/?"+queryString)

  }

  render() {
    const data = this.props;
    let props = {
      ref: this.form,
      name: 'appraisal',
      onSubmit: this.handleSubmit,
    }
    if (this.state.result === 'success') {

      navigate('/thank-you');
      return (
        <section className='contact-body event-form' data-color='#FFF'>
          <div className='contact-body__inner'>
            <h5 className='contact-body__success'><strong></strong></h5>
            <p className='contact-body__success'>Thank you for your entry.<br />OBVIOUS: Good luck.</p>
          </div>
        </section>
      )
    }
    return (
      <>
        <section className='contact-body event-form' data-color='#FFF'>
          <div className='contact-body__inner'>
            <form {...props}>
              <div dangerouslySetInnerHTML={{ __html: data.text }} />
              <input type='hidden' name='page' value={this.state.pathname} />
              <input type='text' name='name' placeholder='Name' onChange={this.handleChange} required />
              <input type='text' name='address' placeholder='Address' onChange={this.handleChange} />
              <input type='text' name='phone' placeholder='Phone Number' onChange={this.handleChange} required />
              <input type='email' name='email' placeholder='Email' onChange={this.handleChange} />
              <input type='text' name='help' placeholder='Tell us about your property goals' onChange={this.handleChange} required />
              <button className='btn' type="submit">{data.buttonText}</button>
              <p className='contact-body__success'>By submitting an entry you are agreeing to our terms and conditions.</p>
            </form>
          </div>
        </section>
      </>
    )
  }
}

export default EventForm
